export type StepRecord = {
  date: string;
  steps: number;
};

// Optional local fallback for daily step totals.
export const stepHistory: StepRecord[] = [];
